
import Modal from "@qc/particle/lib/components/modal"
import Result from "@qc/particle/lib/components/result"
import Spin from "@qc/particle/lib/components/spin";
import './trader.scss';

export function traderTierHandler() {
    const formModal = Modal.info({
      width: '40em',
      wrapClassName: "mktoFormContainer",
      title: (
        <div data-cy="header" style={{textAlign: "center"}}>
          <h3 style={{marginBottom: "0px"}} data-cy="qText">Contact Us</h3>
          <span>You have selected the <b>Trader</b> tier.</span>
        </div>
      ),
      okButtonProps: {
        style: {
          display: 'none'
        }
      },
      closable: true,
      icon: (<></>),
      content: (
        <>
          <Spin id="marketoSpinner" className="onFormLoadHide" size="large" style={{width: '100%'}} />
          <form id="mktoForm_3996" style={{marginTop: "25px"}}></form> 
          <div id="marketoAlreadyRegistered" className="onFormLoadDisplay">
            Have an account? <a href="/selfserve/login">Log In</a>
          </div>
        </>
      ),
    });

    document.querySelectorAll('.onFormLoadHide').forEach(e => e.classList && e.classList.remove('hidden'));
    document.querySelectorAll('.onFormLoadDisplay').forEach(e => e.classList && e.classList.add('hidden'));
    MktoForms2.loadForm("https://info.quantcast.com", "516-DGM-318", 3996, form => {
      document.querySelectorAll('.onFormLoadHide').forEach(e => e.classList && e.classList.add('hidden'));
      document.querySelectorAll('.onFormLoadDisplay').forEach(e => e.classList && e.classList.remove('hidden'));

      document.querySelectorAll('#mktoForm_3996 input').forEach(e => {
        e.classList.add('particle-input');
        e.classList.remove('mktoField');
        e.classList.remove('mktoTextField');
      });
      document.querySelectorAll('#mktoForm_3996 textarea').forEach(e => {
        e.classList.add('particle-input');
        e.classList.remove('mktoField');
      });
      document.querySelectorAll('#mktoForm_3996 label').forEach(e => {
        e.classList.remove('mktoLabel');
      });
      document.querySelectorAll('#mktoForm_3996 select').forEach(e => {
        e.classList.add('particle-input');
      });
      document.querySelectorAll('#mktoForm_3996 button[type=submit]').forEach(e => {
        e.classList.remove('mktoButton');
        e.classList.add('particle-btn');
        e.classList.add('particle-btn-primary');
      });

      form.onSuccess(function(values, followUpUrl) {
          formModal.destroy();

          Modal.success({
            closable: true,
            width: '40em',
            title: '',
            icon: (<></>),
            content: (
              <div id="marketoSubmitSuccessContainer">
                <Result
                  status={"success"}
                  title={"Form Submitted!"}
                  subTitle={
                    <div style={{textAlign: 'left'}}>
                      <p>
                        Hi {values.FirstName},
                      </p>
                      <p>
                        Thank you for contacting Quantcast. A member of our team
                        would reach out to you shortly!
                      </p>
                    </div>
                  }
                >
                </Result>
              </div>
            )
          })

          return false;
      });
    });
  }
